import Vue from "vue";
import Vuex from "vuex";
import * as d3 from "d3";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    /*Authentication*/
    token: null,
    accessLevel: null,
    endDate: null,
    /*Dashboard*/
    csData: null,
    userProfile: null,
    exclusions: [],
  },
  getters: {
    /*Authentication*/
    token: (state) => {
      return state.token;
    },
    accessLevel: (state) => {
      return state.accessLevel;
    },
    endDate: (state) => {
      return state.endDate;
    },
    /*Dashboard*/
    getTopList: (state) => (profile, length = 20, page = 1) => {
      let temp = state.csData.slice();
      temp.sort((a, b) => {
        return compareProfiles(profile, b) - compareProfiles(profile, a);
      });
      return temp.filter((x) => !state.exclusions.includes(x.noc)).slice(0, 20);
    },

    getUserProfile: (state) => {
      return state.userProfile;
    },
    getTopList: (state) => (profile, length = 20, page = 1) => {
      let temp = state.csData.slice();
      temp.sort((a, b) => {
        return compareProfiles(profile, b) - compareProfiles(profile, a);
      });
      temp = temp.filter((x) => !state.exclusions.includes(x.noc));
      if (temp.length > page * length) {
        return temp.slice((page - 1) * length, page * length);
      } else {
        return temp.slice((page - 1) * length);
      }
    },
    getTopListWithSimilarity: (state) => (profile, length = 20, page = 1) => {
      let temp = state.csData.slice();
      temp.sort((a, b) => {
        return compareProfiles(profile, b) - compareProfiles(profile, a);
      });
      temp = temp.filter((x) => !state.exclusions.includes(x.noc));
    },
  },
  mutations: {
    /*Authentication*/
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_ACCESS_LEVEL(state, accessLevel) {
      state.accessLevel = accessLevel;
    },
    SET_END_DATE(state, endDate) {
      state.endDate = endDate;
    },
    /*Dashboard*/
    SAVE_CSDATA(state, data) {
      state.csData = data;
    },
    SAVE_USERPROFILE(state, profile) {
      state.userProfile = profile;
    },
    ADD_EXCLUSION(state, noc) {
      state.exclusions.push(noc);
    },
    CLEAR_EXCLUSIONS(state) {
      state.exclusions = [];
    },
  },
  actions: {
    /*Authentication*/
    setToken(context, token) {
      context.commit("SET_TOKEN", token);
    },
    setAccessLevel(context, accessLevel) {
      context.commit("SET_ACCESS_LEVEL", accessLevel);
    },
    setEndDate(context, endDate) {
      context.commit("SET_END_DATE", endDate);
    },
    /*Dashboard*/
    loadCsData({ commit }) {
      d3.tsv("/data/data.tsv")
        .then((res) => {
          commit("SAVE_CSDATA", res);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setUserProfile({ commit }, profile) {
      commit("SAVE_USERPROFILE", profile);
    },
    addExclusion({ commit }, noc) {
      commit("ADD_EXCLUSION", noc);
    },
    clearExclusions({ commit }) {
      commit("CLEAR_EXCLUSIONS");
    },
  },
  modules: {},
});

function compareProfiles(profile1, profile2) {
  let blueDiff = Math.abs(+profile1.blue - +profile2.blue);
  let greenDiff = Math.abs(+profile1.green - +profile2.green);
  let redDiff = Math.abs(+profile1.red - +profile2.red);
  let yellowDiff = Math.abs(+profile1.yellow - +profile2.yellow);

  let temp =
    100 -
    Math.round(
      Math.sqrt(
        Math.pow(+blueDiff, 2) +
        Math.pow(+greenDiff, 2) +
        Math.pow(+redDiff, 2) +
        Math.pow(+yellowDiff, 2)
      ) / Math.sqrt(2)
    );
  return temp;
}
